export var AutoplayOptions;!function(o){o.NO="NO",o.YES="YES",o.MUTED="MUTED",o.ANY="ANY"}(AutoplayOptions||(AutoplayOptions={}));